import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
	getTimeTrackingTotals,
	getTeamMemberData
} from 'state/actions'

import {
	getCurrentUser,
	getCurrentAccount
} from 'state/selectors'

import {
	doSort,
	getSessionSeconds,
	getColour,
	getPrimaryColumnValue
} from 'utils'

import {
	accentColour
} from 'env'

import moment from 'moment'
import Loader from 'components/loader/loader'
import Checkbox from 'components/input/checkbox'

import { Bar, HorizontalBar, defaults, Chart } from 'react-chartjs-2'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import axios from 'axios'
import { API_URL } from 'state/api'

import windowDimensions from 'react-window-dimensions'

import DeepDiff from 'deep-diff'

class DashboardTimeTrackingOverview extends Component {
	constructor(props) {
		super(props)

		this.state = {
			loading: false,
			currentUserId: this.props.thisUser ? this.props.thisUser.id : this.props.userData.id,
			applicableUserIds: [this.props.userData.id],
			minimumColumns: 7,
			maxColumns: 10,
			includeArchivedTasks: false
		}

		const {
			type
		} = this.props

		Chart.elements.Rectangle.prototype.draw = function () {
			var ctx = this._chart.ctx
			var vm = this._view
			var left, right, top, bottom, signX, signY, borderSkipped, radius

			let x, y, width, height, nextCorner, nextCornerId

			var borderWidth = vm.borderWidth
			var cornerRadius = 7

			if (!vm.horizontal) {
				left = vm.x - vm.width / 2
				right = vm.x + vm.width / 2
				top = vm.y;
				bottom = vm.base;
				signX = 1;
				signY = bottom > top ? 1 : -1
				borderSkipped = vm.borderSkipped || 'bottom'
			} else {
				left = vm.base
				right = vm.x
				top = vm.y - vm.height / 2
				bottom = vm.y + vm.height / 2
				signX = right > left ? 1 : -1
				signY = 1
				borderSkipped = vm.borderSkipped || 'left'
			}

			if (borderWidth) {
				var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom))
				borderWidth = borderWidth > barSize ? barSize : borderWidth
				var halfStroke = borderWidth / 2
				var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0)
				var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0)
				var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0)
				var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0)
				if (borderLeft !== borderRight) {
					top = borderTop
					bottom = borderBottom
				}
				if (borderTop !== borderBottom) {
					left = borderLeft
					right = borderRight
				}
			}

			ctx.beginPath()
			ctx.fillStyle = vm.backgroundColor
			ctx.strokeStyle = vm.borderColor
			ctx.lineWidth = borderWidth

			var corners = [
				[left, bottom],
				[left, top],
				[right, top],
				[right, bottom]
			]

			var borders = ['bottom', 'left', 'top', 'right']
			var startCorner = borders.indexOf(borderSkipped, 0)
			if (startCorner === -1) {
				startCorner = 0
			}

			function cornerAt(index) {
				return corners[(startCorner + index) % 4]
			}

			var corner = cornerAt(0)
			ctx.moveTo(corner[0], corner[1])

			for (var i = 1; i < 4; i++) {
				corner = cornerAt(i)
				nextCornerId = i + 1
				if (nextCornerId == 4) {
					nextCornerId = 0
				}

				nextCorner = cornerAt(nextCornerId)

				width = corners[2][0] - corners[1][0]
				height = corners[0][1] - corners[1][1]
				x = corners[1][0]
				y = corners[1][1]

				var radius = cornerRadius

				// Fix radius being too large
				if (radius > height / 2) {
					radius = height / 2
				} if (radius > width / 2) {
					radius = width / 2
				}

				const thisIndex = this._index
				const thisDataSetIndex = this._datasetIndex
				const dataSets = this._chart.data.datasets

				let rounded = false

				if (type !== 'allocation') {
					rounded = true
				} else {
					const secondSet = dataSets[1].data[thisIndex] // grey

					if (!thisDataSetIndex && !secondSet) {
						rounded = true
					} else if (thisDataSetIndex == 1 && secondSet) {
						rounded = true
					}
				}

				if (rounded) {
					if (type == 'allocation') {
						ctx.moveTo(x + radius, y)
						ctx.lineTo(x + width - radius, y)
						ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
						ctx.lineTo(x + width, y + height - radius)
						ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
						ctx.lineTo(x + radius, y + height)
						ctx.quadraticCurveTo(x, y + height, x, y + height)
						ctx.lineTo(x, y + radius)
						ctx.quadraticCurveTo(x, y, x, y)
					} else {
						ctx.moveTo(x + radius, y)
						ctx.lineTo(x + width - radius, y)
						ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
						ctx.lineTo(x + width, y + height - radius)
						ctx.quadraticCurveTo(x + width, y + height, x + width, y + height)
						ctx.lineTo(x + radius, y + height)
						ctx.quadraticCurveTo(x, y + height, x, y + height)
						ctx.lineTo(x, y + radius)
						ctx.quadraticCurveTo(x, y, x + radius, y)
					}
				} else {
					ctx.moveTo(x, y)
					ctx.lineTo(x + width, y)
					ctx.lineTo(x + width, y + height)
					ctx.lineTo(x, y + height)
					ctx.lineTo(x, y)
				}
			}

			ctx.fill()
			if (borderWidth) {
				ctx.stroke()
			}
		}
	}

    componentWillUnmount = _ => {
        window.addEventListener("resize", this.recalcWidth)
    }

	componentWillMount = _ => {
		const {
			accountData,
			canSelectOtherUsers
		} = this.props

		if (canSelectOtherUsers) {
			axios.get(API_URL + '/accounts/'+accountData.id+'/usersWithSessions').then(response => {
				const userIds = response.data

				this.setState({
					applicableUserIds: userIds
				})
			})

			this.handleChangeUser()
		}

        this.recalcWidth()

        window.addEventListener("resize", this.recalcWidth)

		defaults.global.defaultFontFamily = 'proxima-nova, sans-serif'
	}

	recalcWidth = _ => {
        const screenWidth = this.props.width

		let minimumColumns = 5
		let maxColumns = 5

        if(screenWidth > 1700){
			minimumColumns = 7
			maxColumns = 10
        }else if(screenWidth > 1430){
			minimumColumns = 6
			maxColumns = 6
        }

        if(this.state.minimumColumns !== minimumColumns){
            this.setState({
				minimumColumns,
				maxColumns
            })
        }
    }

	generateChartData = (data, type) => {
		const {
			allSessions,
			allProjects,
			allUsers,
			allTasks,
			project,
			applicableUsers,
			allMilestones,
			userData,
		} = this.props

		const {
			minimumColumns,
			maxColumns,
			currentUserId,
			includeArchivedTasks,
			applicableUserIds
		} = this.state

		const showDarkUi = userData.show_dark_ui

		defaults.global.defaultFontColor = showDarkUi ? 'rgba(255,255,255,0.5)' : '#444'

		const xLabels = []
		const estimatedData = []
		const trackedData = []

		let hasData = false

		switch (type) {
			case 'user':
				const secondsByProject = {}

				let sessionsArray = []

				let users = []

				if(currentUserId > 0){
					thisUser = allUsers[currentUserId]

					users = [thisUser]

					if(thisUser.sessions){
						sessionsArray = thisUser.sessions
					}
				}else{
					applicableUserIds && applicableUserIds.forEach(userId => {
						const user = allUsers[userId]

						users.push(user)

						if(user.sessions){
							sessionsArray = sessionsArray.concat(user.sessions)
						}
					})
				}

				sessionsArray.forEach(sessionId => {
					const sessionObject = allSessions[sessionId]

					if(!sessionObject){
						return
					}
					
					const sessionLength = getSessionSeconds(sessionObject)

					const taskObject = allTasks[sessionObject.task_id]

					const isFromTrashedTask = !taskObject || taskObject.deleted_at || !taskObject.name

					if(!includeArchivedTasks && isFromTrashedTask){
						return 
					}

					if (secondsByProject[sessionObject.project_id]) {
						secondsByProject[sessionObject.project_id].seconds += sessionLength
					} else {
						secondsByProject[sessionObject.project_id] = {
							projectId: sessionObject.project_id,
							seconds: sessionLength
						}
					}
				})

				let sortedProjectGroups = doSort(Object.values(secondsByProject), 'number', 'seconds', true)

				if (sortedProjectGroups.length > maxColumns) {
					sortedProjectGroups.length = maxColumns
				}

				sortedProjectGroups.forEach(projectGroup => {
					const project = allProjects && allProjects[projectGroup.projectId]
					
					if (!project) {
						return
					}

					let estimated = 0

					users.forEach(user => {
						if(user.project_estimate_data && user.project_estimate_data[projectGroup.projectId]){
							estimated += (user.project_estimate_data[projectGroup.projectId] / 60)
						}
					})

					const tracked = Math.round(projectGroup.seconds / 3600)

					if (estimated || tracked) {
						xLabels.push(project.name)

						estimatedData.push(estimated)
						trackedData.push(tracked)
					}
				})

				break
			case 'allocation':
				let thisUser = []

				applicableUsers.forEach(user => {
					thisUser.push({
						user,
						upcomingTasks: [],
						delayedTasks: []
					})
				})

				project && project.milestones.forEach(milestoneId => {
					const milestone = allMilestones[milestoneId]

					if (!milestone || !milestone.tasks) {
						return
					}

					milestone.tasks.forEach(taskId => {
						const task = allTasks[taskId]

						const statusId = getPrimaryColumnValue('status', task, project)
						const taskUsers = getPrimaryColumnValue('people', task, project)

						if (task && !task.deleted_at & statusId !== 3 && taskUsers.length) {
							const taskDates = getPrimaryColumnValue('date', task, project)

							let isLate = false

							if (taskDates && taskDates.end && moment(taskDates.end).isBefore(moment().startOf('day'))) {
								isLate = true
							}

							taskUsers.forEach(userId => {
								const thisUserIndex = thisUser.findIndex(user => {
									return user.user.id == userId
								})

								if (thisUserIndex > -1) {
									if (isLate) {
										thisUser[thisUserIndex].delayedTasks.push(task)
									} else {
										thisUser[thisUserIndex].upcomingTasks.push(task)
									}
								}
							})
						}
					})
				})

				let relevantThisUser = []

				thisUser.forEach(user => {
					if (user.upcomingTasks.length || user.delayedTasks.length) {
						relevantThisUser.push(user)
					}
				})

				relevantThisUser.sort((a, b) => {
					const aTotal = a.upcomingTasks.length + a.delayedTasks.length
					const bTotal = b.upcomingTasks.length + b.delayedTasks.length

					return bTotal - aTotal
				})

				relevantThisUser.forEach(user => {
					xLabels.push(user.user.first_name + ' ' + user.user.last_name)
					trackedData.push(user.upcomingTasks.length)

					estimatedData.push(user.delayedTasks.length)
				})

				break
		}

		estimatedData.forEach((item, index) => {
			estimatedData[index] = Math.round(item * 10)/10
		})

		if (estimatedData.length || trackedData.length) {
			hasData = true
		}

		const barChartData = hasData ? {
			labels: xLabels,
			datasets: [{
				label: type == 'allocation' ? 'Pending tasks' : 'Tracked hours',
				backgroundColor: accentColour(),
				borderColor: 'transparent',
				borderWidth: 1,
				data: trackedData
			}]
		} : null

		if (barChartData) {
			const operation = type == 'allocation' ? 'push' : 'unshift'

			barChartData.datasets[operation]({
				label: type == 'allocation' ? 'Delayed' : 'Estimated hours',
				backgroundColor: type == 'allocation' ? getColour(null, 'red') : showDarkUi ? '#555' : '#ddd',
				borderColor: 'transparent',
				borderWidth: 1,
				data: estimatedData
			})
		}

		const options = {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			tooltips: {
				titleFontColor: '#000',
				bodyFontColor: '#999',
				backgroundColor: '#fff',
				displayColors: false
			},
			scales: {
				ticks: {
					beginAtZero: true,
				},
				yAxes: [{
					maxBarThickness: 20,
					stacked: type == 'allocation',
					gridLines: {
						color: showDarkUi ? 'rgba(255,255,255,0.2)' : '#eee',
					},
					ticks: {
						min: 0,
						beginAtZero: true,
						callback: function (value, index, values) {
							if (typeof value == 'string') {
								return value
							} else if (Math.floor(value) === value) {
								return value
							}
						}
					}
				}],
				xAxes: [{
					stacked: type == 'allocation',
					gridLines: {
						color: showDarkUi ? 'rgba(255,255,255,0.2)' : '#eee',
					},
					barPercentage: 0.8,
					categoryPercentage: 0.5,
					ticks: {
						min: 0,
						beginAtZero: true,
						callback: function (value, index, values) {
							if (typeof value == 'string') {
								return value
							} else if (Math.floor(value) === value) {
								return value
							}
						}
					}
				}]
			}
		}

		if(minimumColumns && barChartData){
			const columnDifference = minimumColumns - barChartData.labels.length

			if(columnDifference > 0 && barChartData.labels.length){
				for (let i = 0; i < columnDifference; i++) {
					barChartData.datasets.forEach(dataset => {
						dataset.data.push(0)
					})
					
					barChartData.labels.push(' ')
				}
			}
		}

		return {
			data: barChartData,
			options
		}
	}

	handleChangeUser = (userId = this.state.currentUserId) => {
		this.setState({
			loading: true
		})

		this.props.getTeamMemberData(userId, true, _ => {
			this.setState({
				loading: false
			})
		})

		this.setState({
			currentUserId: userId
		})
	}

	hasChartData = chartData => {
		if (!chartData) {
			return false
		}

		let hasData = false

		chartData.forEach(month => {
			if (month.totalEstimated || month.totalTracked) {
				hasData = true
			}
		})

		return hasData
	}

	toggleArchivedTasks = _ => {
		this.setState({
			includeArchivedTasks: !this.state.includeArchivedTasks
		})
	}

	getCopy = _ => {
		const {
			type,
			project,
			allUsers,
			userData
		} = this.props

		const {
			currentUserId
		} = this.state

		let title = ''
		let emptyTitle = ''
		let emptyBody = ''

		switch (type) {
			case 'allocation':
				if (!project) {
					return
				}

				title = `Task allocation`
				emptyTitle = `'${project.name}' has no allocated tasks`
				emptyBody = `When your staff have allocated tasks, we'll show who's doing what.`
				break
			case 'user':
				if(currentUserId !== userData.id && currentUserId > 0){
					const user = allUsers[currentUserId]

					title = `${user.first_name}'s top projects`
					emptyTitle = `${user.first_name} hasn't tracked any time yet.`
					emptyBody = `We'll show their most-tracked projects here when they have.`
				}else if(currentUserId < 0){
					title = `Top projects`
					emptyTitle = `Nobody has tracked any time.`
					emptyBody = `We'll show most-tracked projects were when there's any data.`
				}else{
					title = `My top projects`
					emptyTitle = `You haven't tracked any time yet.`
					emptyBody = `We'll show your most-tracked projects here when you have.`
				}
				break
		}

		return {
			title,
			emptyTitle,
			emptyBody
		}
	}

	getDropDownValues = _ => {
		const {
			applicableUserIds
		} = this.state

		const {
			allUsers
		} = this.props

		const userArray = []

		applicableUserIds.forEach(userId => {
			const user = allUsers[userId]

			userArray.push(user)
		})

		return userArray
	}

	render() {
		const {
			loading,
			currentUserId,
			includeArchivedTasks
		} = this.state

		const {
			type,
			isLoading,
			canSelectOtherUsers,
		} = this.props

		const generatedChartData = this.generateChartData(null, type)

		const {
			title,
			emptyTitle,
			emptyBody
		} = this.getCopy()

		const Component = type == 'allocation' ? HorizontalBar : Bar

		return (
			<div className="widget box dashboard-time-tracking-overview">
				<h3>
					{title}
				</h3>
				<div className="controls relative">
					<label>
						<Checkbox 
							isChecked={includeArchivedTasks} 
							onChange={this.toggleArchivedTasks} 
						/>
						Include archived tasks
					</label>
					{canSelectOtherUsers ?
						<div className='folder-selector-dropdown-container visible'>
							<DropdownMenu
								parentType="user"
								parentKey="user_id"
								selectableItems={this.getDropDownValues()}
								isObjects={true}
								selectedItemId={currentUserId}
								handleChange={this.handleChangeUser}
								hasSearch={true}
								hasAll={true}
							/>
						</div>
					: null}
				</div>
				{(generatedChartData && generatedChartData.data && !loading) ?
					<div className="chart-container">
						<Component
							data={generatedChartData.data}
							options={generatedChartData.options}
						/>
					</div>
					:
					<div className="loading-container">
						{(loading || isLoading) ?
							<Loader visible={true} />
							:
							<div className="empty-banner">
								<h2>
									{emptyTitle}
								</h2>
								<p>
									{emptyBody}
								</p>
							</div>
						}
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		allUsers: state.account.entities.users,
		allProjects: state.account.entities.projects,
		allSessions: state.account.entities.sessions,
		allTasks: state.account.entities.tasks,
		accountData: getCurrentAccount(state)
	}
}

export default windowDimensions()(connect(mapStateToProps, {
	getTimeTrackingTotals,
	getTeamMemberData
})(DashboardTimeTrackingOverview))


// WEBPACK FOOTER //
// ./src/sections/dashboard/dashboard-time-tracking-overview.jsx